import React, { useState, useEffect } from 'react';
import { StyledTransportationFilterDiv, StyledTransportationFilterHeaderContainerDiv } from './index.styles';
import { SearchFacetsList, SearchFacetsListCodes } from '../../organisms/OSearchResults/index.constant';
import {
  SearchFacetsResponse,
  SearchFacetsResponseBuckets,
  SearchStateExtendsType,
  SearchStateFilterObj,
} from '../../organisms/OSearchResults/store/store.type';
import {
  StyledOCheckboxItemDiv as StyledCheckboxItemDiv,
  StyledOCheckboxItemsContainer as StyledCheckboxItemsContainer,
} from '../../organisms/OSearchResults/index.styles';
import { CheckBox, checkboxVariation } from '@marriott/mi-ui-library';
import { useWindowSize } from '../../hooks';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/OSearchResults/lib/application.constants';
import { formatNumberByLocale } from '../../utils';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { useConditionalPageContextSERP } from '../../hooks';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const TransportationFilterComponent: React.FC<{
  onItemSelect: (arg: SearchFacetsList, arg2: SearchStateFilterObj) => void;
  clearFilterState: SearchStateExtendsType | undefined | null;
  transportationList?: SearchFacetsResponse;
}> = ({ onItemSelect, clearFilterState, transportationList }) => {
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { currentLocale, pageVal } = useConditionalPageContextSERP() as any;
  const clickTrackingLoc = 'Phoenix Search Results';

  const [currSelectedItem, setCurrSelectedItem] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.transportTypes]
  );
  const { width } = useWindowSize();

  const getCurrTransportation = (): SearchFacetsResponse =>
    // In chat context always use transportationList directly (no selection guard needed).
    // In shop context keep the original !!currSelectedItem guard to avoid regressions.
    (pageVal === 'chat' ? !!transportationList : !!currSelectedItem && transportationList)
      ? (transportationList as SearchFacetsResponse)
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.transportTypes)[0];

  const [transportation, setTransportation] = useState<SearchFacetsResponse>(getCurrTransportation());

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectionChange = (event: any, data: SearchFacetsResponseBuckets): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.type === 'change' || event.keyCode === 13) {
      let obj: SearchStateFilterObj | undefined = { ...currSelectedItem };
      if (obj !== undefined) {
        if (data.code in obj) {
          delete obj[data.code];
        } else {
          obj[data.code] = data.code;
        }
      } else {
        obj = {};
        obj[data.code] = data.code;
      }
      setCurrSelectedItem(obj);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.transportTypes, obj);
      }
    }
    setInteractionsSelected({ ...interactionsSelected, transportation: true });
  };

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrSelectedItem(undefined);
    }
  }, [clearFilterState]);

  const renderTransportation = (transportation: SearchFacetsResponseBuckets, idx: number): JSX.Element => (
    <StyledCheckboxItemDiv className="m-checkbox-selection-item amenity-description" key={idx} tabIndex={-1}>
      <CheckBox
        variation={checkboxVariation.SIMPLE}
        className=""
        checkboxId={`${transportation?.code}-checkbox`}
        checkboxName="city_filter_checkbox"
        onChange={(e): void => onSelectionChange(e, transportation)}
        onKeyDown={(e): void => onSelectionChange(e, transportation)}
        checked={currSelectedItem ? transportation.code in currSelectedItem === true : false}
        inputClassName="checkbox-input custom_click_track"
        setTabIndex={-1}
        value="1"
        children={
          <>
            <span className="t-font-s item-name">{transportation?.label}</span>
            {transportation?.count && (
              <span className="t-font-s pl-1">({formatNumberByLocale(transportation?.count, currentLocale)})</span>
            )}
          </>
        }
        {...{
          custom_click_track_value: `${clickTrackingLoc}| transportation options: ${transportation?.label} |internal`,
        }}
      />
    </StyledCheckboxItemDiv>
  );

  useEffect(() => {
    setTransportation(getCurrTransportation());
  }, [transportationList]);

  return transportation?.buckets.length > 0 ? (
    <StyledTransportationFilterDiv className="t-font-alt-m filter-button">
      <fieldset>
        <StyledTransportationFilterHeaderContainerDiv className="t-font-alt-m">
          <legend>
            <h4
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-subtitle-m`) + ' filter-heading'
              }
            >
              {transportation?.type?.label}
            </h4>
          </legend>
        </StyledTransportationFilterHeaderContainerDiv>

        <StyledCheckboxItemsContainer>
          {transportation?.buckets?.map((d: SearchFacetsResponseBuckets, i: number) => renderTransportation(d, i))}
        </StyledCheckboxItemsContainer>
      </fieldset>
      <hr aria-hidden className="filter-separator" />
    </StyledTransportationFilterDiv>
  ) : (
    <div></div>
  );
};
